import { configureStore } from '@reduxjs/toolkit';
import categoriesReducer from './categoriesSlice.js';
import productsReducer from './productsSlice';

const store = configureStore({
  reducer: {
    categories: categoriesReducer,
    products: productsReducer,
  },
});

export default store;